export const size = (multiplier = 1, baseUnit = 8) => {
  return `${(multiplier * baseUnit) / 16}rem`;
};
